import React from 'react';
import { motion } from 'framer-motion';

export default function VideoLoopBlock({ data }) {
  const { video } = data;

  return (
    <section className="bg-white clip-right-top clip-left-bottom -mt-20">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        viewport={{ once: true }}
        className="">
        <video src={video} className='w-full' loop muted playsInline preload autoPlay />
      </motion.div>
    </section>
  );
}
